import React from 'react';
import { useTranslation } from 'react-i18next';

const ClubListButtons = ({ data, onSuspend, onRemove }) => {
    const { t } = useTranslation();
    return (
        <div className="clubListButtons">
            <button className="clubListButton clubListSuspend" onClick={onSuspend}>{t('suspend')}</button>
            {!data.founder ? (
                <button className="clubListButton clubListRemove" onClick={onRemove}>{t('remove')}</button>
            ) : false}
        </div>
    );
};

export default ClubListButtons;